import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoTooltip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00016 11.1668V8.50016M8.00016 5.8335H8.00683M14.6668 8.50016C14.6668 12.1821 11.6821 15.1668 8.00016 15.1668C4.31826 15.1668 1.3335 12.1821 1.3335 8.50016C1.3335 4.81826 4.31826 1.8335 8.00016 1.8335C11.6821 1.8335 14.6668 4.81826 14.6668 8.50016Z",
		stroke: "#596180",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInfoTooltip;
